import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { onboardingApplicationStepAndFieldStatus, OnboardingApplicationStepAndFieldStatus } from "consts/onboarding";
import Loader from "ui/molecules/Loader";
import type { WithFieldsStatus } from "./types";
import { useApplicationDetailContext } from "../../ApplicationDetailProvider";

type Props = WithFieldsStatus<{
    readonly status: OnboardingApplicationStepAndFieldStatus;
    readonly isLoading: boolean;
}>;

const FieldsStatus = ({
    status,
    total,
    statusTotal
}: Props) => {
    const { isLoading } = useApplicationDetailContext();

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                gap: 2
            }}
        >
            <Chip
                {...onboardingApplicationStepAndFieldStatus.get(status)!}
                size='medium'
            />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: .5
                }}
            >
                <Loader
                    isLoading={isLoading}
                    slotProps={{
                        progress: {
                            size: 18
                        }
                    }}
                >
                    {statusTotal}
                </Loader>
                /
                <Loader
                    isLoading={!total}
                    slotProps={{
                        progress: {
                            size: 18
                        }
                    }}
                >
                    {total}
                </Loader>
            </Box>
        </Box>
    );
};

export default FieldsStatus;
